// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1eetV","footer":"ModalUpdate_footer__18dTU"};